import React from "react";
import { Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "../ProtectedRoute";

// import HomePage from "../../pages/Home";
import Account from "../../pages/Account";
import AccountsList from "../../pages/Admin/AccountsList";
import LicenseContainer from "../../pages/LicenseContainer";
import CloudLicensesList from "../../pages/Admin/License/CloudLicensesList";
import CloudUserLicensesList from "../../pages/Admin/License/CloudUserLicensesList";
import NewLicenseForm from "../../pages/Admin/License/NewLicenseForm";
import ChannelsList from "../../pages/Channels";
import ChannelDetailView from "../../pages/ChannelDetailView";
import NodeDashboard from "../../pages/Node/NodeDashboard";
import NodeChannelEdit from "../../pages/NodeChannelEdit";
import NodeSystem from "../../pages/Node/NodeSystem";
import NodeLicenseList from "../../pages/Node/NodeLicenseList";
import NodesListView from "../../pages/NodesListView";
import ShareNodeForm from "../../pages/ShareNodeForm";
import NotificationsPage from "../../pages/NotificationsPage";
import OrganizationPage from "../../pages/OrganizationPage";
import OrganizationsPage from "../../pages/Admin/Organizations";
import OrganizationPageAssign from "../../pages/OrganizationPageAssign";
import UserDetailView from "../../pages/UserDetailView";
import CloudNodes from "../../pages/CloudNodes";

import NodeChannelDetailView from "../../pages/Node/NodeChannelDetailView";

const NavigationLayoutRoutes = () => (
  <Switch>
    <ProtectedRoute path="/" exact component={ChannelsList} />
    <ProtectedRoute path="/account" exact component={Account} />
    <ProtectedRoute path="/qs-hub/organization" exact component={OrganizationPage} />
    <ProtectedRoute path="/organization/edit" exact component={OrganizationPageAssign} />
    <ProtectedRoute path="/users/:username" exact component={UserDetailView} />
    <ProtectedRoute path="/admin/accounts" exact component={AccountsList} />
    <ProtectedRoute path="/qs-hub/organizations" exact component={OrganizationsPage} />
    <ProtectedRoute path="/licenses" exact component={LicenseContainer} />
    <ProtectedRoute path="/cloud/licenses" exact component={CloudLicensesList} />
    <ProtectedRoute path="/cloud/nodes" exact component={CloudNodes} />
    <ProtectedRoute path="/cloud/licenses/:username" exact component={CloudUserLicensesList} />
    <ProtectedRoute path="/admin/license/new" exact component={NewLicenseForm} />
    <ProtectedRoute path="/qs-hub/hub-channels" exact component={ChannelsList} />
    <ProtectedRoute exact path="/virtual-channel/:type/:id" component={ChannelDetailView} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/channels" component={NodeDashboard} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/system" component={NodeSystem} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/licenses" component={NodeLicenseList} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/channel/edit/:id" component={NodeChannelEdit} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/channel/:id" component={NodeChannelDetailView} />
    <ProtectedRoute exact path="/nodes-management" component={NodesListView} />
    <ProtectedRoute exact path="/node/:cwid/:cnn/manage-access" component={ShareNodeForm} />
    <ProtectedRoute exact path="/notifications" component={NotificationsPage} />
    <Redirect to="/login" />
  </Switch>
);

export default NavigationLayoutRoutes;
